import Cookies from 'js-cookie'
import {constantRouterMap,initRouter} from '../../router';
import { getRouters } from '@/api/sys/resource'
// !+Cookies.get('sidebarStat')
const app = {
  state: {
    sidebar: 0,
    routers:  constantRouterMap,
    serverRouter: null,
    menuTheme: 'dark',
    currentPathArr: [],
    pageOpenedList: JSON.parse(localStorage.getItem("openTagList")) || [{
      name: "home_index",
      path: "/home",
      title: "首页"
    }],
    routerPath: localStorage.getItem("routerPath") || ''
  },
  mutations: {
    SET_SERVER_ROUTER: (state, routers) => {
      state.serverRouter = routers;
    },
    SET_ROUTERS: (state, routers) => {
      state.routers = constantRouterMap.concat(routers);
    },
    SET_SIDEBAR: state => {
      Cookies.set('sidebarStat', state.sidebar ? 1 : 0);
      state.sidebar = !state.sidebar
    },
    SET_currentPathArr: (state, currentPathArr) => {
      state.currentPathArr = currentPathArr
    },
    setRouterPath: (state, routerPath) => {
      state.routerPath = routerPath
    },
    addPageOpened: (state, tag) => {
      let flag = true;
      state.pageOpenedList.map((item, index) => {
        if (item.name === tag.name) {
          flag = false;
        }
      });
      if (flag) {
        state.pageOpenedList.push(tag);
        // localStorage.setItem("openTagList",JSON.stringify(state.pageOpenedList));
      }
      // 设置大于五个就删除一个
      // if (state.pageOpenedList.length > 5) {
      //   state.pageOpenedList.splice(1, 1);
      // }
    },
    closeOnePageOpend: (state, name) => {
      state.pageOpenedList.map((item, index) => {
        if (item.name === name) {
          state.pageOpenedList.splice(index, 1);
        }
      });
      // localStorage.setItem("openTagList",JSON.stringify(state.pageOpenedList));
    },
    clearAllPageTags: (state) => {
      state.pageOpenedList = [{
        name: "home_index",
        path: "/home",
        title: "首页"
      }];
      // localStorage.setItem("openTagList",JSON.stringify(state.pageOpenedList));
    },
    clearOtherPageTags: (state, name) => {
      let newPageList = [];
      state.pageOpenedList.map((item, index) => {
        if (item.name === name || item.name === "home_index") {
          newPageList.push(item)
        }
      });
      state.pageOpenedList = newPageList;
      // localStorage.setItem("openTagList",JSON.stringify(state.pageOpenedList));
    },
    ChangeMenuTheme: (state, name) => {
      if (state.menuTheme === 'dark') {
        state.menuTheme = 'light';
      } else {
        state.menuTheme = 'dark';
      }
    }
  },
  actions: {
    ChangeSidebar: ({commit}) => {
      commit('SET_SIDEBAR')
    },
    GenerateRoutes({state, commit}, data) {
      return new Promise(resolve => {
        // 向后端请求路由数据
        getRouters().then(res => {
          let buildRouter =  initRouter(res.data);
          commit('SET_ROUTERS', buildRouter)
          commit('SET_SERVER_ROUTER', buildRouter);
          resolve(buildRouter)
        })

      })
    },
    ChangeCurrentPathArr({commit}, data) {
      commit('SET_currentPathArr', data);
    }
  }
}

export default app



// WEBPACK FOOTER //
// ./src/store/modules/app.js